import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'recordingShareModalShown',
  'recordingShareCopyLinkClick',
  'recordingSharePageShown',
  'recordingShareLoginClick',
  'recordingShareTryItFreeClick',
] as const;

export const recordingShareEvents = getMappedEvents([...EVENTS], {
  shouldSendSubscriptionData: true,
});
